<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Consumption List (खतावणी)</h2>
        </div>

        <div class="card p-4 mb-4">
            
                <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">
                    <!-- Start Date -->
                    <div class="w-full lg:w-auto mt-4">
                        <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                        <input type="date" id="startDate" v-model="startDate" class=" border border-gray-300 rounded w-full" />
                    </div>
                    
                    <!-- End Date -->
                    <div class="w-full lg:w-auto ml-2">
                        <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                        <input type="date" id="endDate" v-model="endDate" class=" border border-gray-300 rounded w-full" />
                    </div>
        
                     <!-- Filter Button -->
                     <div class="w-50 lg:w-auto ml-2 mt-5">
                        <button type="button" @click.prevent="filterPurchases" class="btn b-solid btn-primary-solid px-5 cursor-pointer w-full lg:w-auto mt-2 lg:mt-6">Filter</button>
                    </div>
                    
                 
                           <!-- Plot Name Filter -->
                  <div class="w-full lg:w-auto ml-2">
                    <label for="searchplot" class="block text-sm font-medium text-gray-700">Branch Name</label>
                    <select class="form-input" id="branch_name" ref="branchName" v-model="sale.branchid">
                        <option value=""></option>
                        <option value="All">All</option>
                        <option v-for="(item, index) in branchList" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </select>
                </div>


                    <!-- Plot Name Filter -->
                  <div class="w-full lg:w-auto ml-2">
                    <label for="searchplot" class="block text-sm font-medium text-gray-700">Search Plot</label>
                    <select class="form-input" id="plot_name" ref="plotName" v-model="sale.plotid">
                        <option value=""></option>
                        <option value="All">All</option>
                        <option v-for="(item, index) in plotList" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </select>
                </div>
                    
                     <!-- Employee Name Filter -->
                 <div class="w-full lg:w-auto ml-2">
                    <label for="searchemp" class="block text-sm font-medium text-gray-700">Search Employee</label>
                    <select class="form-input" id="cust_name" ref="employeeName" v-model="sale.custid">
                        <option value=""></option>
                        <option value="All">All</option>
                        <option v-for="(item, index) in employeeList" :key="item.id" :value="item.id">{{ item.name + ' ' + item.contact }}</option>
                    </select>
                </div>


                
                <!-- Product Name Filter -->
                <!-- <div class="w-full lg:w-auto ml-2">-->
                <!--    <label for="searchprod" class="block text-sm font-medium text-gray-700">Search Product</label>-->
                <!--    <select class="form-input" id="prd_name" ref="productName" v-model="prd.prdid">-->
                <!--        <option value=""></option>-->
                <!--        <option value="All">All</option>-->
                <!--        <option v-for="(item, index) in productsList" :key="item.id" :value="item.id">{{ item.name }}</option>-->
                <!--    </select>-->
                <!--</div>-->
                    
                   
                </div>
          
        </div>
        
            <!-- Loading Spinner -->
          

            <!--<div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">-->
            <!--    <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">-->
            <!--        Export-->
            <!--    </button>-->
            <!--</div>-->

            <div class="printonly">
                From {{startDate}} To {{endDate}}
            </div>



            <div class="card">
                <!-- Static heading -->
                <div id="printable-content">
                    <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                    <h1 class="print-only" style="text-align: center;">Consumption List (खतावणी)</h1>
                </div>

                <button
                    type="reset"
                    @click="printReceipt"
                    class="btn b-light btn-danger-light btn-sm"
                >
                    Print
                </button>
                </div>



            
              


            <div class="grid grid-cols-12">
                <!-- INITIALIZE CSS CLASS -->
                <div class="tablejs sr-only size-0"></div>
                  <!-- LOADING SPINNER -->
                    
                <!-- BASIC DATA TABLE -->
                <div class="col-span-full" v-if="isTableVisible">
                    <div class="card p-0">
                        <div class="p-2 space-y-4">
                            <!-- RESPONSIVE WRAPPER -->
                            <div class="overflow-x-auto">
                                <table id="basicDataTable" class="datatable w-full min-w-[800px]">
                                    <thead>
                                        <tr>
                                            <th class="bg-[#B2E8D9]">Bill No</th>
                                            <th class="bg-[#B2E8D9]">Date</th>
                                            <th class="bg-[#B2E8D9]">Employee Name</th>
                                            <th class="bg-[#B2E8D9]">Branch Name</th>
                                            <th class="bg-[#B2E8D9]">Plot Name</th>
                                            <th class="bg-[#B2E8D9]">Taaki</th>
                                            <th class="bg-[#B2E8D9]">Gher</th>
                                            <th class="bg-[#B2E8D9]">Res</th>
                                            <th class="bg-[#B2E8D9]">Pressure</th>
                                            <th class="bg-[#B2E8D9]">Fan</th>
                                            <th class="bg-[#B2E8D9]">Ghan</th>
                                            <th class="bg-[#B2E8D9]">Water</th>
                                            <th class="bg-[#B2E8D9]">Note</th>
                                            <th class="bg-[#B2E8D9]">Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                        <!-- Loop through filteredSaleList -->
                                        <tr v-for="(item, index) in filteredSaleList" :key="item.id">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.entry_date }}</td>
                                            <td @click="filterCustomer(item.custid)">{{ item.cust_name }}</td>
                                            <td>{{ item.branch_name }}</td>
                                            <td>{{ item.plot_name }}</td>
                                            <td>{{ item.taaki }}</td>
                                            <td>{{ item.ghe }}</td>
                                            <td>{{ item.re }}</td>
                                            <td>{{ item.pressure }}</td>
                                            <td>{{ item.fan }}</td>
                                            <td>{{ item.ghan }}</td>
                                            <td>{{ item.water }}</td>
                                            <td>{{ item.remark }}</td>

                                            <td>
                                                <div class="flex items-center gap-1">
                                                    <div class="flex items-center gap-1">
                                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                                        </button>
                                                    </div>

                                                    <button class="btn-icon btn-primary-icon-light size-7" @click="SaleView(item.id)">
                                                        <i class="ri-edit-line text-success text-[13px]"></i>
                                                    </button>


                                                    <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.id)">
                                                        <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
               <div class="col-span-full" v-if="isLoading"> Please Wait Data Is Loading....</div>
            </div>
            
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'SaleList',
components: {
 
},

watch: {
        // saleconsumptionList () { // data used in the table
        //   this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
        //      $('.datatable').DataTable().draw();
        //      this.reinitializeDataTable();
        //   })
        //  },
         
     },

mounted(){
 this.getBasics();
//  this.getBasicsData();
 $(this.$refs.plotName).select2({
            placeholder: 'Select Plot',
            allowClear: true
        });

        $(this.$refs.employeeName).select2({
            placeholder: 'Select Employee',
            allowClear: true
        });

        $(this.$refs.productName).select2({
            placeholder: 'Select Product',
            allowClear: true
        });
},
watch: {
    // filteredSaleList () {
        
    //     // this.$nextTick(() => {
    //     //     $('.datatable').DataTable().destroy();
    //     //     this.$nextTick(() => {
    //     //         $('.datatable').DataTable();
    //     //     });
    //     // });
        
            
    //      },
     },
data() {
    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
     endDate: today,
     isTableVisible: false, // Initially table is hidden
     sale: {
            plotid: null,
            custid: null,
            branchid:null,
        },
        filters: {
            fromDate: this.getTodayDate(),
            toDate: this.getTodayDate(),
        },
        prd: {
            prdid: null
        },
     saleList:[],
     branchList:[],
     isLoading: false, // Flag for loading spinner
     filteredSaleList: [],
     plotList: [], // plot options
        employeeList: [], // employee options
        productsList: [],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
    }
 }, 
 
 computed: {
     
    // filteredSaleList() {
    //     return this.saleList.filter((item) => {
    //         // Convert date strings to Date objects for comparison
    //         let saleDate = new Date(item.entry_date);
    //         let fromDate = this.filters.fromDate ? new Date(this.filters.fromDate) : null;
    //         let toDate = this.filters.toDate ? new Date(this.filters.toDate) : null;

    //         // Check if the sale falls within the date range
    //         let withinDateRange = true;
    //         if (fromDate && saleDate < fromDate) withinDateRange = false;
    //         if (toDate && saleDate > toDate) withinDateRange = false;

    //         // Filter by other fields (plot, customer, product)
    //         return (
    //             withinDateRange &&
    //             (!this.sale.plotid || this.sale.plotid === item.plotid) &&
    //             (!this.sale.custid || this.sale.custid === item.custid) &&
    //             (!this.prd.prdid || this.prd.prdid === item.prdid)
    //         );
    //     });


    //      // Destroy and reinitialize DataTable
    //      this.$nextTick(() => {
    //         $('.datatable').DataTable().destroy();
    //         this.$nextTick(() => {
    //             $('.datatable').DataTable();
    //         });
    //     });

    // }



    
},
methods:{
    getTodayDate() {
      const today = new Date();
      return today.toISOString().substr(0, 10); // Returns the date in 'YYYY-MM-DD' format
    },
    // exportToExcel() {
    //     // Prepare the CSV header
    //     const headers = ["id", "entry_date", "cust_name", "plot_name", "taaki", "ghe","re","remark"];
    //     const rows = this.filteredSaleList.map(item => [
    //     this.formatDate(item.iddate),
    //     this.formatDate(item.entry_date),
    //         item.cust_name,
    //         item.plot_name,
    //         item.taaki,
    //         item.ghe,
    //         item.re,
    //         item.remark,
    //     ]);

    //     // Combine headers and rows into a CSV string
    //     const csvContent = [headers, ...rows]
    //         .map(row => row.map(value => `"${value}"`).join(","))
    //         .join("\n");

    //     // Create a Blob from the CSV content
    //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    //     const url = URL.createObjectURL(blob);

    //     // Trigger a download
    //     const link = document.createElement("a");
    //     link.setAttribute("href", url);
    //     link.setAttribute("download", "Consumption_Report.csv");
    //     link.style.display = "none";
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // },
    formatDate(date) {
    if (!date) return "";  // Return empty string if date is missing or null
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";  // Return empty if invalid date
    return d.toLocaleDateString();  // Format the date as per your requirement
},
    // onFilterChange() {
    //     // This will trigger the recomputation of filteredSaleList due to Vue reactivity
    //     this.filteredSaleList = this.saleList.filter((item) => {
    //         let saleDate = new Date(item.entry_date);
    //         let fromDate = this.filters.fromDate ? new Date(this.filters.fromDate) : null;
    //         let toDate = this.filters.toDate ? new Date(this.filters.toDate) : null;

    //         // Check date range filter
    //         let withinDateRange = true;
    //         if (fromDate && saleDate < fromDate) withinDateRange = false;
    //         if (toDate && saleDate > toDate) withinDateRange = false;

    //         // Return filtered results based on date, plot, customer, and product
    //         return (
    //             withinDateRange &&
    //             (!this.sale.plotid || this.sale.plotid === item.plotid) &&
    //             (!this.sale.custid || this.sale.custid === item.custid) &&
    //             (!this.prd.prdid || this.prd.prdid === item.prdid)
    //         );


    //           // Destroy and reinitialize DataTable
    //     //   this.$nextTick(() => {
    //     //     $('.datatable').DataTable().destroy();
    //     //     this.$nextTick(() => {
    //     //         $('.datatable').DataTable();
    //     //     });
    //     // });

    //     });
    // },


    closeModal(){
     
     $("#editModal").addClass('hidden');
     $("#deleteModal").addClass('hidden');
         this.isAdd=0;
         this.isEdit=0;
         this.isDelete=0;
         this.deleteId=0;
  },

  deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },




    async getBasicsData(response) {
        // this.isLoading = true; // Show the spinner while filtering
          var self=this;
                                        self.destroyTable();
            
                    self.productsList=response.data.products;
                    self.employeeList=response.data.employees; 
                    self.plotList=response.data.plots; 
                    self.branchList=response.data.branchlist; 
                    self.employees=response.data.userDetails;
               
                   
                                 self.prd_select_tag= $("#prd_name").select2({
                                    width: '100%',
                                    dropdownAutoWidth : true,
                                    placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a ref='add_product' class='  btn-primary-icon-light size-7'>Add Product</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                  }).on('change', function (event) {
                                        self.destroyTable();
                                        self.selectedProduct = self.productsList.find(item => item.id === event.target.value);
                                         if(self.selectedProduct){
                                            self.prd={...self.selectedProduct};
                                            self.prd.prdid=self.selectedProduct.id;
                                            self.batchnos=self.prd.batchlist;
                                            // self.filteredSaleList = self.saleList.filter((item)=>{ return (item.cust_name===self.selectedProduct.name))});
                                            }else{
                                                self.filteredSaleList = self.saleList;
                                            }
                                            self.initiateTable();
                                        // self.prd.manufacturingdate = self.batchnos[0].mfgDate.split(' ')[0]; 
                                        // self.prd.expirydate = self.batchnos[0].expiryDate.split(' ')[0];     

                                        // self.getTotal();
                                        // setTimeout(() => { self.$refs.batch_no.focus();}, 200)
                                        // self.$refs.qty.focus();
                                    });  

                                    $("#cust_name").select2({
                                        width: '100%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        self.destroyTable();
                                        var selected_customer = self.employeeList.find(item => item.id === event.target.value);
                                           if(selected_customer){
                                        
                                            self.sale.custid=selected_customer.id;
                                            self.sale.custcell=selected_customer.contact;
                                            self.sale.custaddress=selected_customer.address;
                                            self.sale.balance=selected_customer.balance;
                                             
                                            self.filteredSaleList = self.saleList.filter((item)=>{ return (item.cust_name && item.cust_name.includes(selected_customer.name))});
                                            }else{
                                                self.filteredSaleList = self.saleList;
                                            }
                                            // self.prd_select_tag.select2('open');
                                            self.initiateTable();
                                        });  

                                        $("#plot_name").select2({
                                        width: '100%',
                                        height:"25px",
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Plot Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                          self.destroyTable();
                                        var selected_plot = self.plotList.find(item => item.id === event.target.value);
                                        if(selected_plot){
                                            self.sale.plotid=selected_plot.id;
                                            self.sale.custcell=selected_plot.cell;
                                            self.sale.custgst=selected_plot.gst;
                                            self.sale.custaddress=selected_plot.address;
                                            self.sale.balance=selected_plot.balance;
                                            self.filteredSaleList = self.saleList.filter(item => item.plotid === event.target.value);
                                        }else{
                                            self.filteredSaleList = self.saleList;
                                        }
                                            // self.prd_select_tag.select2('open');

self.initiateTable();
                                        }); 




                                        $("#branch_name").select2({
                                        width: '100%',
                                        height:"25px",
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                            self.destroyTable();
                                        var selected_branch = self.branchList.find(item => item.id === event.target.value);
                                        if(selected_branch){
                                            self.filteredSaleList = self.saleList.filter(item => item.branchid === event.target.value);
                                        }else{
                                            self.filteredSaleList = self.saleList;
                                        }
                                           // self.prd_select_tag.select2('open');
                                        self.initiateTable();

                                        }); 














                        
     },
 
destroyTable(){
    this.isLoading=true;
   if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }  
},

initiateTable(){
     if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }  
    var self=this;
    this.$nextTick(() => {
           self.datatable=$('.datatable').DataTable( {
                        dom: 'Bfrtip',
                        buttons: [
                            'print',
                            'excelHtml5',
                            'csvHtml5',
                            'pdfHtml5'
                        ]
                    } );
            this.isLoading=false;
    } );
},

    print_invoice(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/consumptionPrint?q='+id, '_blank'); 
        },

         SaleView(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/SaleView?q='+id, '_blank'); 
        },



        printReceipt() {
          this.destroyTable();
             window.print();
    },


  
 async getBasics() {
       var self=this;
         axios.post('getSales').then(function (response) {
                self.destroyTable();
                 self.saleList=response.data.saleList;
                 //self.filteredSaleList=response.data.saleList;
                 self.employees=response.data.userDetails;
                 self.getBasicsData(response);
                }).then(()=>{ 
                    self.initiateTable();
                    // = $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });
              
                      }); 
  }, 
 async filterCustomer(custid) {
       var self=this;
         axios.post('getCustomerSales',{custid:custid}).then(function (response) {
              self.destroyTable();
                 self.saleList=response.data.saleList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
                   // $(".datatable").DataTable().destroy();
                  self.initiateTable(); }); 
  }, 


            delete_category() {
                var self = this; 
                axios.post('deletesalelist', {deleteId:this.deleteId})
                    .then(response => {
                        // self.productsList=response.data.products;
                        // self.employees=response.data.userDetails; 
                        self.filterPurchases();
                         self.closeModal(); 
                         //location.reload();
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },

            filterPurchases() {
                var self=this;
                self.showLoader(true);
                
                   axios.post('getSales',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
                        self.destroyTable();
                         self.saleList=response.data.saleList;
                         self.filteredSaleList=response.data.saleList;
                         self.employees=response.data.userDetails;
                         self.getBasicsData(response);
                         self.showLoader(false);
                        }).then(()=>{ 
                            // self.isTableVisible=true;
                          self.initiateTable();
              
                    }); 
                    
                    
                    
    //  alert('original_size'+this.filteredSaleList.length);
            // let filteredList = this.filteredSaleList;
            // this.filteredSaleList=[];
            // // Apply date filtering
            // if (this.startDate) {
            //     $('.datatable').DataTable().clear();
            //     self.filteredSaleList = this.saleList.filter((item) => {
            //                 return (new Date(item.entry_date) >= new Date(self.startDate)) && (new Date(item.entry_date) <= new Date(self.endDate))
            //         });
                    
            //   // alert('after_size'+this.filteredSaleList.length);
            // }
       
                 // Show table only if data is available
                //  this.isTableVisible = this. filteredSaleList.length > 0;
           
           // Destroy and reinitialize DataTable
        //    this.$nextTick(() => {
        //     $('.datatable').DataTable().destroy();
        //     this.$nextTick(() => {
        //         // $('.datatable').DataTable();
        //     });
        // });

            
        },

        showLoader(show){
            if(show){
                $("#loader").show();
                 this.isTableVisible=false;
            }
            else{
                $("#loader").hide();
                this.isTableVisible=true;
            }
            
        }


}
}
</script>


<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
        display: block; 
    }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    .loading-spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top: 5px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

    </style>
    



